import classnames from "classnames";
import { Cell } from "react-table";
import { genericMemo } from "../../../../../../utils";
import { Column } from "../../../TableContainer";

import styles from "../style.module.scss";

const bodyCellProps = { className: styles.dottedValue };

type BodyCellProps<T extends object> = { className?: string, style?: object, cell: Cell<T, any>, };

export const BodyCell = genericMemo(
  <T extends object>(props: BodyCellProps<T>) => {
    const { className, style, cell, ...cellProps } = props;
    const declaredColumn = (cell.column as Column<T>);
    const declaredCellProps = declaredColumn?.getCellProps?.(cell, "body");
    return (
      <div
        {...cellProps}
        {...declaredCellProps}
        style={{
          ...style,
          ...declaredCellProps?.style,
          // minWidth: cell.column.minWidth,
        }}
        className={classnames(
          className,
          styles.cell,
          styles.bodyCell,
          { [styles.selectionCell]: declaredColumn.freezeOnScroll },
          declaredCellProps?.className,
        )}
        role="cell"
      >
        {cell.render("Cell", { bodyCellProps })}
      </div>
    );
  },
);

export default BodyCell;
